import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  IconButton,
  MenuItem,
  InputAdornment,
  Alert
} from "@mui/material";
import { FiEye, FiEyeOff, FiEdit } from "react-icons/fi";
import CloseIcon from "@mui/icons-material/Close";
import { motion } from "framer-motion";

const EditStudentModal = ({ open, onClose, student, onSave }) => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    class: "",
    status: ""
  });
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");

  // Load student data when modal opens
  useEffect(() => {
    if (student) {
      setFormData({
        name: student.name || "",
        email: student.email || "",
        phone: student.contact || "",
        class: student.class || "",
        status: student.status || ""
      });
      setPassword(""); // Reset password field
      setError("");
    }
  }, [student]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

 const handleSave = () => {
  if (!formData.name || !formData.email) {
    setError("Name and Email are required!");
    return;
  }

  setError("");

  // Convert status to boolean for backend
  const statusBoolean = formData.status === "Active" ? true : false;

  // Build payload
  const payload = {
    ...formData,
    id: student.id,
    status: statusBoolean
  };

  // Include password only if admin entered something
  if (password) {
    payload.password = password;
  }

  onSave(payload);
  onClose();
};


  
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle
        sx={{ m: 0, p: 2, display: "flex", justifyContent: "space-between" }}
      >
        <motion.div
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4 }}
          style={{
            fontWeight: "bold",
            fontSize: "1.4rem",
            color: "#1976d2",
            display: "flex",
            alignItems: "center",
            gap: "8px"
          }}
        >
          <FiEdit /> Edit Student
        </motion.div>

        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{ position: "absolute", top: 8, right: 8, color: "red" }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent
        component={motion.div}
        sx={{ maxHeight: "70vh", overflowY: "auto" }}
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.3 }}
      >
        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

        <TextField
          fullWidth
          label="Full Name"
          name="name"
          value={formData.name}
          onChange={handleChange}
          margin="dense"
          required
        />

        <TextField
          fullWidth
          label="Email"
          name="email"
          type="email"
          value={formData.email}
          onChange={handleChange}
          margin="dense"
          required
        />

        <TextField
          fullWidth
          label="Mobile Number"
          name="phone"
          type="tel"
          value={formData.phone}
          onChange={handleChange}
          margin="dense"
        />

        {/* <TextField
          fullWidth
          label="Class"
          name="class"
          value={formData.class}
          onChange={handleChange}
          margin="dense"
          select
        >
          <MenuItem value="10">10th</MenuItem>
          <MenuItem value="11">11th</MenuItem>
          <MenuItem value="12">12th</MenuItem>
        </TextField> */}

        <TextField
          fullWidth
          label="Password"
          type={showPassword ? "text" : "password"}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          margin="dense"
          InputProps={{
            endAdornment: (
              <InputAdornment position="end" onClick={() => setShowPassword(!showPassword)}>
                {showPassword ? <FiEyeOff cursor="pointer" /> : <FiEye cursor="pointer" />}
              </InputAdornment>
            )
          }}
        />

        <TextField
          fullWidth
          label="Status"
          name="status"
          value={formData.status}
          onChange={handleChange}
          margin="dense"
          select
        >
          <MenuItem value="Active">Active</MenuItem>
          <MenuItem value="Inactive">Inactive</MenuItem>
        </TextField>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} color="error" variant="outlined">
          Cancel
        </Button>
        <Button
          onClick={handleSave}
          variant="contained"
          color="primary"
          disabled={!formData.name || !formData.email}
        >
          Save Changes
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditStudentModal;
